export const BREAK_PLOT_MAX_IN = 30;
